// import React, { useEffect, useState, useCallback } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { closePayMenuNew, paymenIsSuccessfull } from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import { debounce } from 'lodash';
// import { useNavigate } from "react-router-dom";
// //import {closePayMenuNew} from '../../../Redux/action/interactions';

// const PayMenu = () => {
//     const data = JSON.parse(localStorage.getItem('data')) || {};
//     const userID = localStorage.getItem('userID');
//     const [amount, setAmount] = useState('');
//     const [message, setMessage] = useState();
//     const paySuccess = useSelector(state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     console.log("hchdvsdsdjvsdvsidfjvn",dispatch);
//     const [play] = useSound(successSound);
//     const [isButtonDisabled, setButtonDisabled] = useState(false);
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);

//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     }

//     const disableButton = () => {
//         setButtonDisabled(true);
//     };

//     const enableButton = () => {
//         setButtonDisabled(false);
//     };

//     const messageChange = (event) => {
//          setMessage(event.target.value);
//      };

//     useEffect(() => {
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if (menuItems) {
//             const orderSummary = menuItems.map(item => `${item.name}*${item.quantity}=${item.amt}`).join(', ');
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
//             setAmount(orderAmt < 200 ? 200 : orderAmt);
//         }
//         enableButton();
//     }, []);

//     useEffect(() => {
//         if (userID && data.empid && data.token) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//     }, [userID, order]);

//     const payAmount = useCallback(debounce(() => {
//         if (data && userID) {
//             const amt = parseInt(amount);
//             if (amt < 200) {
//                 toast.error("The transaction amount must be greater than 200 for Miscelleneous Payment!");
//                 enableButton();
//                 return;
//             }

//             canteenPay(userID, data.empid, data.token, amt, message)
//                 .then(response => {
//                     if (response.data.message === "INVALIDDRAMOUNT") {
//                         dispatch(closePayMenuNew(false));
//                         toast.error("Insufficient Balance, Please Recharge Your Wallet");
//                     } else if (response.data.message === "success" && response.data.response === "OK") {
//                         dispatch(closePayMenuNew(false));
//                         dispatch(paymenIsSuccessfull());
//                         play();
//                         toast.success("Paid Successfully", { duration: 4000 });
//                     }
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch(() => {
//                     toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });
//                     dispatch(closePayMenuNew(false));
//                 });
//         }
//     }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

//     const handlePay = (event) => {
//         event.preventDefault();
//         disableButton();
//         payAmount();
//     };

//     const handleCancel = () => {
//         //console.log('Cancel button clicked');
//         dispatch(closePayMenuNew(false));
//     };

//     return (
//         <div className={classes.PayMenuContainer}>
//             <h1>Pay Amount</h1>
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
//             <input 
//                 type="number" 
//                 placeholder="₹" 
//                 onChange={amountChange} 
//                 value={amount} 
//                 min={200} 
//             />

//             <input className="Message"
//             type="text"  
//             placeholder='Add Message' 
//             onChange={messageChange} 
//             value={message}
//             required
//             />
      
//             <div className={classes.ButtonDiv}>
//                 <button  onClick={handlePay}>PAY</button>
//                 <button onClick={() => {dispatch(closePayMenuNew(true))}}>CANCEL</button>                
//             </div>
//         </div>
//     );
// };

// export default PayMenu;

















//////////////////////////////BACK UP CODE /////////////////////////////////////////////////

// import React, { useEffect, useState, useCallback } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { closePayMenuNew, paymenIsSuccessfull } from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import { debounce } from 'lodash';
// import { useNavigate } from "react-router-dom";

// const PayMenu = () => {
//     const exemptedEmployees = [69, 75, 339, 73, 7056]; // Exempted employee IDs
//     const data = JSON.parse(localStorage.getItem('data')) || {};
//     const userID = localStorage.getItem('userID');
//     const [amount, setAmount] = useState('');
//     const [message, setMessage] = useState();
//     const paySuccess = useSelector(state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     const [play] = useSound(successSound);
//     const [isButtonDisabled, setButtonDisabled] = useState(false);
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);

//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     }

//     const disableButton = () => {
//         setButtonDisabled(true);
//     };

//     const enableButton = () => {
//         setButtonDisabled(false);
//     };

//     const messageChange = (event) => {
//          setMessage(event.target.value);
//      };

//     useEffect(() => {
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if (menuItems) {
//             const orderSummary = menuItems.map(item => `${item.name}*${item.quantity}=${item.amt}`).join(', ');
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
//             setAmount(orderAmt < 200 ? 200 : orderAmt);
//         }
//         enableButton();
//     }, []);

//     useEffect(() => {
//         if (userID && data.empid && data.token) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//     }, [userID, order]);

//     const payAmount = useCallback(debounce(() => {
//         if (data && userID) {
//             const amt = parseInt(amount);
//             if (!exemptedEmployees.includes(parseInt(userID)) && amt < 200) {
//                 toast.error("The transaction amount must be greater than 200 for Miscellaneous Payment!");
//                 enableButton();
//                 return;
//             }

//             canteenPay(userID, data.empid, data.token, amt, message)
//                 .then(response => {
//                     if (response.data.message === "INVALIDDRAMOUNT") {
//                         dispatch(closePayMenuNew(false));
//                         toast.error("Insufficient Balance, Please Recharge Your Wallet");
//                     } else if (response.data.message === "success" && response.data.response === "OK") {
//                         dispatch(closePayMenuNew(false));
//                         dispatch(paymenIsSuccessfull());
//                         play();
//                         toast.success("Paid Successfully", { duration: 4000 });
//                     }
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch(() => {
//                     toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });
//                     dispatch(closePayMenuNew(false));
//                 });
//         }
//     }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

//     const handlePay = (event) => {
//         event.preventDefault();
//         disableButton();
//         payAmount();
//     };

//     const handleCancel = () => {
//         dispatch(closePayMenuNew(false));
//     };

//     return (
//         <div className={classes.PayMenuContainer}>
//             <h1>Pay Amount</h1>
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
//             <input 
//                 type="number" 
//                 placeholder="₹" 
//                 onChange={amountChange} 
//                 value={amount} 
//                 min={0} // Allow any amount input
//             />

//             <input className="Message"
//             type="text"  
//             placeholder='Add Message' 
//             onChange={messageChange} 
//             value={message}
//             required
//             />
      
//             <div className={classes.ButtonDiv}>
//                 <button onClick={handlePay} >PAY</button>
//                 <button onClick={handleCancel}>CANCEL</button>                
//             </div>
//         </div>
//     );
// };

// export default PayMe4nu;















// import React, { useEffect, useState, useCallback } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { closePayMenuNew, paymenIsSuccessfull } from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import { debounce } from 'lodash';
// import { useNavigate } from "react-router-dom";


// const PayMenu = () => {
//     const exemptedEmployees = [69, 75, 339, 73, 7056]; 
//     const data = JSON.parse(localStorage.getItem('data')) || {};
//     const userID = localStorage.getItem('userID');
//     const [amount, setAmount] = useState('');
//     const [message, setMessage] = useState();
//     const paySuccess = useSelector(state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     const [play] = useSound(successSound);
//     const [isButtonDisabled, setButtonDisabled] = useState(false);
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
    
   
//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     }

//     const disableButton = () => {
//         setButtonDisabled(true);
//     };

//     const enableButton = () => {
//         setButtonDisabled(false);
//     };

//     const messageChange = (event) => {
//          setMessage(event.target.value);
//      };

//     useEffect(() => {
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if (menuItems) {
//             const orderSummary = menuItems.map(item => `${item.name}*${item.quantity}=${item.amt}`).join(', ');
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
//             setAmount(orderAmt < 200 ? 200 : orderAmt);
//         }
//         enableButton();
//     }, []);

//     useEffect(() => {
//         if (userID && data.empid && data.token) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//     }, [userID, order]);

//     const handlePay = (event) => {
//         event.preventDefault();
//         disableButton();
//         payAmount();
//         dispatch(closePayMenuNew(false));
//     };

//     const payAmount = useCallback(debounce(() => {
//         if (data && userID) {
//             const amt = parseInt(amount);
//             if (!exemptedEmployees.includes(parseInt(userID)) && amt < 200) {
//                 toast.error("The transaction amount must be greater than 200 for Miscellaneous Payment!");
//                 enableButton();
//                 return;
//             }

//             canteenPay(userID, data.empid, data.token, amt, message)
//                 .then(response => {
//                     if (response.data.message === "INVALIDDRAMOUNT") {
//                         dispatch(closePayMenuNew(false));
//                         toast.error("Insufficient Balance, Please Recharge Your Wallet");
//                     } else if (response.data.message === "success" && response.data.response === "OK") {
//                         dispatch(closePayMenuNew(false));
//                         dispatch(paymenIsSuccessfull());
//                         play();
//                         toast.success("Paid Successfully", { duration: 4000 });
//                     }
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch(() => {
//                     toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });
//                     dispatch(closePayMenuNew(false));
//                 });
//         }
//     }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

   

//     const handleCancel = () => {
//         dispatch(closePayMenuNew(false));
//         console.log("Cancel button clicked");
//     };

//     return (
//         <div className={classes.PayMenuContainer}>
//             <h1>Pay Amount</h1>
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
      
//             <input 
//                 type="number" 
//                 placeholder="₹" 
//                 onChange={amountChange} 
//                 value={amount} 
//                 min={0} 
//             />
      
//             <input className="Message"
//             type="text"  
//             placeholder='Add Message' 
//             onChange={messageChange} 
//             value={message}
//             required
//             />
      
//             <div className={classes.ButtonDiv}>
//                 <button onClick={handlePay} >PAY</button>
//                 <button onClick={handleCancel}>CANCEL</button>
//             </div>
//         </div>
//     );
// };

// export default PayMenu;











// import React, { useEffect, useState, useCallback } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { closePayMenuNew, paymenIsSuccessfull } from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import { debounce } from 'lodash';
// import { useNavigate } from "react-router-dom";

// const PayMenu = () => {
//     const exemptedEmployees = [69, 75, 339, 73, 7056]; 
//     const data = JSON.parse(localStorage.getItem('data')) || {};
//     const userID = localStorage.getItem('userID');
//     const [amount, setAmount] = useState('');
//     const [message, setMessage] = useState('');
//     const [isMenuVisible, setIsMenuVisible] = useState(true); // State to control visibility
//     const paySuccess = useSelector(state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     const [play] = useSound(successSound);
//     const [isButtonDisabled, setButtonDisabled] = useState(false);
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);

//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     };

//     const disableButton = () => {
//         setButtonDisabled(true);
//     };

//     const enableButton = () => {
//         setButtonDisabled(false);
//     };

//     const messageChange = (event) => {
//          setMessage(event.target.value);
//     };

//     useEffect(() => {
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if (menuItems) {
//             const orderSummary = menuItems.map(item => `${item.name}*${item.quantity}=${item.amt}`).join(', ');
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
//             setAmount(orderAmt < 200 ? 200 : orderAmt);
//         }
//         enableButton();
//     }, []);

//     useEffect(() => {
//         if (userID && data.empid && data.token) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//     }, [userID, order]);

//     const payAmount = useCallback(debounce(() => {
//         if (data && userID) {
//             const amt = parseInt(amount);
//             if (!exemptedEmployees.includes(parseInt(userID)) && amt < 200) {
//                 toast.error("The transaction amount must be greater than 200 for Miscellaneous Payment!");
//                 enableButton();
//                 return;
//             }

//             canteenPay(userID, data.empid, data.token, amt, message)
//                 .then(response => {
//                     if (response.data.message === "INVALIDDRAMOUNT") {
//                         dispatch(closePayMenuNew(false));
//                         toast.error("Insufficient Balance, Please Recharge Your Wallet");
//                     } else if (response.data.message === "success" && response.data.response === "OK") {
//                         dispatch(closePayMenuNew(false));
//                         dispatch(paymenIsSuccessfull());
//                         play();
//                         toast.success("Paid Successfully", { duration: 4000 });
//                     }
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch(() => {
//                     toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });
//                     dispatch(closePayMenuNew(false));
//                 })
//                 .finally(() => {
//                     enableButton();
//                 });
//         }
//     }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

//     const handlePay = (event) => {
//         event.preventDefault();
//         disableButton();
//         payAmount();
//     };

//     const handleCancel = () => {
//         dispatch(closePayMenuNew(false));
//         setIsMenuVisible(false); // Hide the payment menu
//         console.log("Cancel button clicked");
//     };

//     if (!isMenuVisible) {
//         return null; // If the menu is not visible, render nothing
//     }

//     return (
//         <div className={classes.PayMenuContainer}>
//             <h1>Pay Amount</h1>
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
      
//             <input 
//                 type="number" 
//                 placeholder="₹" 
//                 onChange={amountChange} 
//                 value={amount} 
//                 min={0} 
//                 disabled={isButtonDisabled}
//             />
      
//             <input className="Message"
//             type="text"  
//             placeholder='Add Message' 
//             onChange={messageChange} 
//             value={message}
//             required
//             disabled={isButtonDisabled}
//             />
      
//             <div className={classes.ButtonDiv}>
//                 <button onClick={handlePay} >PAY</button>
//                 <button onClick={handleCancel} >CANCEL</button>
//             </div>
//         </div>
//     );
// };

// export default PayMenu;












// import React, { useEffect, useState, useCallback } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { closePayMenuNew, paymenIsSuccessfull } from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import { debounce } from 'lodash';
// import { useNavigate } from "react-router-dom";

// const PayMenu = () => {
//     const exemptedEmployees = [69, 75, 339, 73, 7056]; 
//     const data = JSON.parse(localStorage.getItem('data')) || {};
//     const userID = localStorage.getItem('userID');
//     const [amount, setAmount] = useState('');
//     const [message, setMessage] = useState('');
//     const [isMenuVisible, setIsMenuVisible] = useState(true); 
//     const [isLoading, setIsLoading] = useState(false); // Loading state for feedback
//     const paySuccess = useSelector(state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     const [play] = useSound(successSound);
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);

//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     };

//     const messageChange = (event) => {
//         setMessage(event.target.value);
//     };

//     useEffect(() => {
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if (menuItems) {
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
//             setAmount(orderAmt < 200 ? 200 : orderAmt);
//         }
//     }, []);

//     useEffect(() => {
//         if (userID && data.empid && data.token) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//     }, [userID, order]);

//     const payAmount = useCallback(debounce(() => {
//         if (data && userID) {
//             const amt = parseInt(amount);
//             if (!exemptedEmployees.includes(parseInt(userID)) && amt < 200) {
//                 toast.error("The transaction amount must be greater than 200 for Miscellaneous Payment!");
//                 setIsLoading(false);
//                 return;
//             }

//             canteenPay(userID, data.empid, data.token, amt, message)
//                 .then(response => {
//                     if (response.data.message === "INVALIDDRAMOUNT") {
//                         dispatch(closePayMenuNew(false));
//                         toast.error("Insufficient Balance, Please Recharge Your Wallet");
//                     } else if (response.data.message === "success" && response.data.response === "OK") {
//                         dispatch(closePayMenuNew(false));
//                         dispatch(paymenIsSuccessfull());
//                         play();
//                         toast.success("Paid Successfully", { duration: 4000 });
//                     }
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch(() => {
//                     toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });
//                     dispatch(closePayMenuNew(false));
//                 })
//                 .finally(() => {
//                     setIsLoading(false);
//                 });
//         }
//     }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

//     const handlePay = (event) => {
//         event.preventDefault();
//         if (!isLoading) {  // Prevent multiple clicks during processing
//             setIsLoading(true);
//             payAmount();
//         }
//     };

//     const handleCancel = () => {
//         dispatch(closePayMenuNew(false));
//         setIsMenuVisible(false);
//         console.log("Cancel button clicked");
//     };

//     if (!isMenuVisible) {
//         return null;
//     }

//     return (
//         <div className={classes.PayMenuContainer}>
//             <h1>Pay Amount</h1>
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
      
//             <input 
//                 type="number" 
//                 placeholder="₹" 
//                 onChange={amountChange} 
//                 value={amount} 
//                 min={0} 
//                 disabled={isLoading}
//             />
      
//             <input className="Message"
//             type="text"  
//             placeholder='Add Message' 
//             onChange={messageChange} 
//             value={message}
//             required
//             disabled={isLoading}
//             />
      
//             <div className={classes.ButtonDiv}>
//                 <button onClick={handlePay} disabled={isLoading}>{isLoading ? 'Processing...' : 'PAY'}</button>
//                 <button onClick={handleCancel}>CANCEL</button>
//             </div>
//         </div>
//     );
// };

// export default PayMenu;











// import React, { useEffect, useState, useCallback } from 'react';
// import classes from './CanteenPay.module.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import useSound from 'use-sound';
// import successSound from './../../../utilities/success.mp3';
// import { closePayMenuNew, paymenIsSuccessfull } from './../../../Redux/action/interactions';
// import { canteenPay, walletHistory } from './../../../API/API';
// import { debounce } from 'lodash';
// import { useNavigate } from "react-router-dom";

// const PayMenu = () => {
//     const exemptedEmployees = ['XVTEMP230']; 
//     const data = JSON.parse(localStorage.getItem('data')) || {};
//     const userID = localStorage.getItem('userID');
//     const [amount, setAmount] = useState('');
//     const [message, setMessage] = useState('');
//     const [isMenuVisible, setIsMenuVisible] = useState(true); 
//     const paySuccess = useSelector(state => state.interactions.paymentSuccess);
//     const dispatch = useDispatch();
//     const [play] = useSound(successSound);
//     const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);

//     const amountChange = (event) => {
//         setAmount(event.target.value);
//     };

//     const messageChange = (event) => {
//         setMessage(event.target.value);
//     };
//     const [isButtonDisabled, setButtonDisabled] = useState(false);
//     const disableButton = () => {
//         setButtonDisabled(true);
//     };

//     useEffect(() => {
//         const menuItems = JSON.parse(localStorage.getItem('order'));
//         if (menuItems) {
//             const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
//             setAmount(orderAmt < 200 ? 200 : orderAmt);
//         }
//     }, []);

//     useEffect(() => {
//         if (userID && data.empid && data.token) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//     }, [userID, order]);

//     const payAmount = useCallback(debounce(() => {
//         if (data && userID) {
//             const amt = parseInt(amount);
//             if (!exemptedEmployees.includes(parseInt(userID)) && amt < 200) {
//                 toast.error("The transaction amount must be greater than 200 for Miscellaneous Payment!");
//                 return;
//             }

//             canteenPay(userID, data.empid, data.token, amt, message)
//                 .then(response => {
//                     if (response.data.message === "INVALIDDRAMOUNT") {
//                         dispatch(closePayMenuNew(false));
//                         toast.error("Insufficient Balance, Please Recharge Your Wallet");
//                     } else if (response.data.message === "success" && response.data.response === "OK") {
//                         dispatch(closePayMenuNew(false));

//                     // Dispatch payment success
//                         dispatch(paymenIsSuccessfull());

//                     // Play success sound           
//                         play();
//                         toast.success("Paid Successfully", { duration: 4000 });
//                     }

//                    // Redirect to dashboard 
//                     if (order) navigate("/dashboard/canteenpay");
//                 })
//                 .catch(() => {
//                     toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });

//                 // Close the payment menu in both cases    
//                     dispatch(closePayMenuNew(false));
//                 });
//         }
//     }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

//     const handlePay = (event) => {
//         event.preventDefault();
//         disableButton();
//         payAmount();
//         setIsMenuVisible(false);
//     };

//     const handleCancel = () => {
//         dispatch(closePayMenuNew(false));
//         setIsMenuVisible(false);
//         //console.log("Cancel button clicked");
//     };

//     if (!isMenuVisible) {
//         return null;
//     }

//     return (
//         <div className={classes.PayMenuContainer}>
//             <h1>Pay Amount</h1>
//             <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
      
//             <input 
//                 type="number" 
//                 placeholder="₹" 
//                 onChange={amountChange} 
//                 value={amount} 
//                 min={0} 
//             />
      
//             <input 
//                className="Message"
//                type="text"  
//                placeholder='Add Message' 
//                onChange={messageChange} 
//                value={message}
//                required
//             />
      
//             <div className={classes.ButtonDiv}>
//                 <button disabled={isButtonDisabled} onClick={handlePay}>PAY</button>
//                 <button onClick={handleCancel}>CANCEL</button>
//             </div>
//         </div>
//     );
// };

// export default PayMenu;














import React, { useEffect, useState, useCallback } from 'react';
import classes from './CanteenPay.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import useSound from 'use-sound';
import successSound from './../../../utilities/success.mp3';
import { closePayMenuNew, paymenIsSuccessfull } from './../../../Redux/action/interactions';
import { canteenPay, walletHistory } from './../../../API/API';
import { debounce } from 'lodash';
import { useNavigate } from "react-router-dom";

const PayMenu = () => {
    const exemptedEmployees = ['7056','DIRERS','DIRFIN','DIRSYS','DIRPROJ','XVTEMP230']; 
    const data = JSON.parse(localStorage.getItem('data')) || {};
    const userID = localStorage.getItem('userID');
    const [amount, setAmount] = useState('');
    const [message, setMessage] = useState('');
    const [isMenuVisible, setIsMenuVisible] = useState(true); 
    const paySuccess = useSelector(state => state.interactions.paymentSuccess);
    const dispatch = useDispatch();
    const [play] = useSound(successSound);
    const [order, setOrder] = useState(JSON.parse(localStorage.getItem('order')) || []);
    const navigate = useNavigate();
    const [transHistory, setHistory] = useState([]);

    const amountChange = (event) => {
        setAmount(event.target.value);
    };

    const messageChange = (event) => {
        setMessage(event.target.value);
    };

    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const disableButton = () => {
        setButtonDisabled(true);
    };

    useEffect(() => {
        const menuItems = JSON.parse(localStorage.getItem('order'));
        if (menuItems) {
            const orderAmt = menuItems.reduce((sum, item) => sum + item.amt, 0);
            setAmount(orderAmt < 200 ? 200 : orderAmt);
        }
    }, []);

    useEffect(() => {
        if (userID && data.empid && data.token) {
            walletHistory(userID, data.empid, data.token)
                .then(response => {
                    setHistory(response.data);
                })
                .catch(() => {
                    setHistory([]);
                    toast("Unable to Fetch Wallet History", {
                        icon: '❗',
                        duration: 4500
                    });
                });
        }
    }, [userID, order]);

    const payAmount = useCallback(debounce(() => {
        if (data && userID) {
            const amt = parseInt(amount);

            // Check if the user is exempted from the payment limit
            const isExempted = exemptedEmployees.includes(userID);

            // If not exempted and amount is less than 200, show an error
            if (!isExempted && amt < 200) {
                toast.error("The transaction amount must be greater than 200 for Miscellaneous Payment!");
                return;
            }

            canteenPay(userID, data.empid, data.token, amt, message)
                .then(response => {
                    if (response.data.message === "INVALIDDRAMOUNT") {
                        dispatch(closePayMenuNew(false));
                        toast.error("Insufficient Balance, Please Recharge Your Wallet");
                    } else if (response.data.message === "success" && response.data.response === "OK") {
                        dispatch(closePayMenuNew(false));

                        // Dispatch payment success
                        dispatch(paymenIsSuccessfull());

                        // Play success sound           
                        play();
                        toast.success("Paid Successfully", { duration: 4000 });
                    }

                    // Redirect to dashboard 
                    if (order) navigate("/dashboard/canteenpay");
                })
                .catch(() => {
                    toast.error("Canteen Payment Not Working. Try Again Later.", { duration: 4000 });

                    // Close the payment menu in both cases    
                    dispatch(closePayMenuNew(false));
                });
        }
    }, 100), [amount, message, userID, data, dispatch, play, order, navigate]);

    const handlePay = (event) => {
        event.preventDefault();
        disableButton();
        payAmount();
        setIsMenuVisible(false);
    };

    const handleCancel = () => {
        dispatch(closePayMenuNew(false));
        setIsMenuVisible(false);
        //console.log("Cancel button clicked");
    };

    if (!isMenuVisible) {
        return null;
    }

    return (
        <div className={classes.PayMenuContainer}>
            <h1>Pay Amount</h1>
            <h2>Wallet Balance: ₹ {transHistory.length > 0 ? transHistory[0].total : " "}</h2>
      
            <input 
                type="number" 
                placeholder="₹" 
                onChange={amountChange} 
                value={amount} 
                min={0} 
            />
      
            <input 
               className="Message"
               type="text"  
               placeholder='Add Message' 
               onChange={messageChange} 
               value={message}
               required
            />
      
            <div className={classes.ButtonDiv}>
                <button disabled={isButtonDisabled} onClick={handlePay}>PAY</button>
                <button onClick={handleCancel}>CANCEL</button>
            </div>
        </div>
    );
};

export default PayMenu;
